export default __webpack_public_path__ + "static/media/Wildstrider Gloves.1576c57e.jpg";